import React from "react";
import "../../App.css";

const Apropos = () => {
  return (
    <section
      id="apropos"
      className="min-h-screen bg-gray-100 flex flex-col justify-center items-center py-12"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-[#03224C] mb-8 md:mb-12 text-center">
        A propos de moi
      </h2>

      {/* Contenu en deux colonnes */}
      <div className="flex flex-col md:flex-row items-center md:items-start w-11/12 sm:w-4/5 md:w-3/4 lg:w-2/3 mx-auto">
        <div className="md:w-1/2 mb-8 md:mb-0 md:mr-12">
          <img
            src="/images/moi.jpg"
            alt="À propos de moi"
            className="rounded-full w-60 h-60 sm:w-72 sm:h-72 md:w-80 md:h-80 object-cover mx-auto shadow-lg" // Ajustement des dimensions de l'image
          />
        </div>

        <div className="md:w-2/3 text-black text-base sm:text-lg md:text-lg leading-relaxed text-justify animate__animated animate__zoomIn animate__delay-1s">
          <p className="mb-4">
            Développeur Web Full Stack, spécialisé dans la conception
            d’applications web modernes, performantes et sécurisées.
            J’interviens aussi bien sur le front-end que sur le back-end, ce qui
            me permet de concevoir des solutions complètes, de l’interface
            utilisateur à la logique métier.
          </p>
          <p>
            J’aime travailler avec des technologies modernes pour créer des
            applications interactives, dynamiques et centrées sur l’expérience
            utilisateur. Curieux et rigoureux, je m’investis dans l’amélioration
            continue de mes compétences et dans la découverte de nouvelles
            technologies afin de rester à jour et relever de nouveaux défis
            techniques.
          </p>

          <div className="mt-6 text-center md:text-left">
            <a
              href="/cv.pdf"
              download
              className="bg-[#03224C] text-white px-6 py-3 rounded-md shadow-md hover:bg-blue-700 transition-colors duration-300 inline-block"
            >
              Télécharger mon CV
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Apropos;
